module.exports = __webpack_public_path__ + "static/media/048.bec2bc07.png";